import React, { useContext, useEffect } from "react";
import { Button, Navbar, Container } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../../assets/footer/Frame 143724931.svg";
import "./header.css";
import { ThemeContext } from "../../context/themeProvider";
import Offcanvas from "react-bootstrap/Offcanvas";
import userService from "../../services/userService";
import Dropdown from "react-bootstrap/Dropdown";
import { useSelector } from "react-redux";

const Header = () => {
  const { theme } = useContext(ThemeContext);
  const user = JSON.parse(useSelector((state) => state.user.user));
  const navigate = useNavigate();

  useEffect(() => {
    // console.log(theme, 'theme value')
    document.body.classList.toggle("dark-theme", theme === "dark");
    document.body.classList.toggle("light-theme", theme === "light");
  }, [theme]);

  useEffect(() => {
    // Scroll to the top of the page on route change
    window.scrollTo(0, 0);
    let isVisited = userService.getVisit();
    if (!isVisited) visitCount();
  }, []);

  const scrollToForm = () => {
    let path = window.location.pathname;
    if (path !== "/" && path !== "/rewards") {
      navigate("/rewards#join");
      setTimeout(() => {
        let ele = document.getElementById("join-form");
        ele.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 1000);
    } else {
      let ele = document.getElementById("join-form");
      ele.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const visitCount = async () => {
    try {
      const response = await userService.visitCount();
      if (response.error) {
        console.log(
          response?.error?.message ||
            "Something went worng in getting user details"
        );
      } else {
        userService.setVisit();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {[false, "lg"].map((expand) => (
        <Navbar
          key={expand}
          expand={expand}
          className="bg-dark mb-3"
          variant="dark"
          fixed="top"
        >
          <Container>
            <Navbar.Brand>
              {" "}
              <a href={window.location.origin}>
                <img src={logo} alt="logo" height="50" width="50" />{" "}
              </a>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
              variant="dark"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title
                  id={`offcanvasNavbarLabel-expand-${expand}`}
                ></Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body className="d-flex justify-content-end m-0 p-0">
                {/* <Nav className="justify-content-center flex-grow-1 pe-3 me-auto m-auto">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="1"
                      as={NavLink}
                      to="/"
                      className="active-nav-link"
                    >
                      Home
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Dropdown data-bs-theme="dark">
                      <Dropdown.Toggle
                        id="menu-dropdown-btn"
                        variant="dark"
                        className="manu-dropdown-btn"
                      >
                        Product
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="home-dropdown-menu">
                        <Dropdown.Item className="nav-dropdown-items">
                          <Nav.Link
                            as={NavLink}
                            to="/product"
                            eventKey="2"
                          >
                            FOCII
                          </Nav.Link>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="3"
                      as={NavLink}
                      to="/rewards"
                      className="active-nav-link"
                    >
                      Rewards
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="4"
                      as={NavLink}
                      to="/science"
                      className="active-nav-link"
                    >
                      Science
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="6"
                      as={NavLink}
                      to="/blog"
                      className="active-nav-link"
                    >
                      Blog
                    </Nav.Link>
                  </Nav.Item>
                </Nav> */}

                <div className="increase-width-in-mobile">
                  <Nav>
                    <Nav.Link eventKey="5" as={NavLink} to="/login">
                      {" "}
                      <Button
                        variant="outline-light"
                        className="mob_join w-100"
                      >
                        {!user ? "Login" : "View Dashboard"}
                      </Button>
                    </Nav.Link>
                    {!user && (
                      <Button
                        variant="outline-light"
                        className="mob_join"
                        onClick={() => scrollToForm()}
                      >
                        Register
                      </Button>
                    )}

                    {/* <ToggleSwitch Name="header" /> */}
                  </Nav>
                </div>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  );
};

export default Header;
